import React from 'react';

const StudioDemandSection = () => {
  return (
    <section className="sd-section">
      <div className="sd-card position-relative overflow-hidden" style={{ position: 'relative', overflow: 'hidden' }}>
        <div className="glow-effect-bg" style={{ left: '7%', top: '29%' }}></div>
        <div className="glow-effect-bg" style={{ left: 'auto', right: '8%', top: '34%' }}></div>
        <span className="sd-badge" style={{ position: 'relative', zIndex: 1 }}>Your studio, on demand</span>
        <h2 className="sd-title" style={{ position: 'relative', zIndex: 1 }}>
          Your Next Photoshoot Is<br />
          <span className="sd-highlight">Already Done.</span>
        </h2>
        <p className="sd-subtitle" style={{ position: 'relative', zIndex: 1 }}>
          Join 500+ Jewellery brands generating campaign-ready visuals in<br className="d-none d-md-block" />
          seconds — not weeks.
        </p>
        <a href="/appdownload" style={{ position: 'relative', zIndex: 1 }}><button className="sd-btn">Download App</button></a>
      </div>
    </section>
  );
};

export default StudioDemandSection;
